import axios, { AxiosInstance } from 'axios';

export class FetcherAxios {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create();
  }

  public post(url: string, data: any): Promise<any> {
    return this.axiosInstance.post(url, data);
  }

  public get(url: string): Promise<any> {
    return this.axiosInstance.get(url);
  }

  public put(url: string, data: any): Promise<any> {
    return this.axiosInstance.put(url, data);
  }

  public delete(url: string): Promise<any> {
    return this.axiosInstance.delete(url);
  }
}
